module.exports = __webpack_public_path__ + "img/thank-you-thumbs-up.004ea1eb.svg";